"use strict"

angular.module("core")
.service("SalesRepUnpaidInvoicesStatementPrintButtonService", function(
    common, FlashBag, gettextCatalog, appConfig, $q, $resource, ZebraPrinterService
) {
    this.PDF_LETTER_FORMAT = "letter";
    this.PDF_RECEIPT_FORMAT = "receipt";

    var resource = $resource(appConfig.API_SERVER + "/invoice/" + appConfig.APP + "/sales-rep/unpaid-statement/pdf/:pdfFormat/:outputType/", {
        pdfFormat: "@pdfFormat",
        outputType: "@outputType"
    }, {
        create: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.downloadPDF = function(id, pdfFormat) {
        return resource.save({
            pdfFormat: pdfFormat,
            outputType: "print"
        }).$promise.then(function onSuccess(data) {
            var file_data = data.file_data;
            if (file_data) {
                var file_name = data.file_name;
                common.downloadFile(file_data, file_name, {type: "application/pdf;charset=utf-8;"});
            }
            else {
                FlashBag.preformattedError(gettextCatalog.getString("There is an error while trying to generate the file."));
            }
        });
    }

    this.printReceiptPDF = function(id, forceSelectPrinter) {
        return resource.save({
            pdfFormat: this.PDF_RECEIPT_FORMAT,
            outputType: "print"
        }).$promise.then(function onSuccess(data) {
            return ZebraPrinterService.defaultResponseCallback(data, forceSelectPrinter);
        });
    }

    this.emailPDF = function(id, pdfFormat, recipient) {
        return resource.save({
            email: recipient,
            pdfFormat: pdfFormat,
            outputType: "email"
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/unpaid-invoices-statement-print-button/sales-rep-unpaid-invoices-statement-print-button.service.js
// module id = 419
// module chunks = 0